<template>
  <details-sheet :item="request" :headers="headers" v-bind="$attrs">
    <template v-slot:item.customer="{ item }">
      {{ name }}
    </template>
    <template v-slot:item.address="{ item }">
      {{ address }}
    </template>
  </details-sheet>
</template>

<script>
import DetailsSheet from '@/modules/_global/_components/DetailsSheet';

export default {
  name: 'PersonDetails',

  components: {
    DetailsSheet
  },

  props: {
    request: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ORDERS.CUSTOMER'),
          value: 'customer'
        },
        {
          text: this.$t('ITEM.ADDRESS'),
          value: 'address'
        },
        {
          text: this.$t('PROFILE.PHONE'),
          value: 'person.personal_profile.phone'
        },
        {
          text: this.$t('PROFILE.EMAIL'),
          value: 'person.user.email'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'apartment.building.building_complex.name'
        },
        {
          text: this.$t('APARTMENTS.ITEM'),
          value: 'apartment.name'
        }
      ];
    },

    name() {
      if (!this.request.person) {
        return '';
      }

      const { first_name = '', last_name = '' } = this.request.person;

      return `${first_name} ${last_name}`;
    },

    address() {
      if (!this.request.person.personal_profile) {
        return '';
      }

      const street = this.request.person.personal_profile.street || '';
      const zip = this.request.person.personal_profile.zip || '';
      const city = this.request.person.personal_profile.city || '';

      return `${street}, ${zip} ${city}`.replace(/^[\s,]+|[\s,]+$/g, '');
    }
  }
};
</script>
